import React, { useState } from "react";
import { decartEdit } from "./Services/ApiServices/chatServices";
import "bootstrap/dist/css/bootstrap.min.css";

const DecartUploadEdit = () => {
  const [file, setFile] = useState(null);
  const [referenceFile, setReferenceFile] = useState(null);
  const [prompt, setPrompt] = useState("");

  const getDefaultTryOnPrompt = () =>
    "Change the subject’s shirt to a white knitted sweater with a teddy bear design on the back. Match the reference image, realistic fabric texture and natural folds, preserve original pose and motion, consistent lighting.";

  const [referenceMode, setReferenceMode] = useState("both");
  const [mode, setMode] = useState("lucy"); // lucy (default) | virtual-try-on
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileType, setFileType] = useState(null); // 'image' or 'video'



  const handleSubmit = async () => {
    // For video Lucy supports reference-image only edits with an empty prompt.
    if (!file) return;


    setLoading(true);

    const formData = new FormData();
    formData.append("image", file); // Keeping the same key for compatibility
    formData.append(
      "prompt",
      referenceMode === "reference"
        ? ""
        : (prompt && prompt.trim().length > 0 ? prompt : getDefaultTryOnPrompt())
    );
    formData.append("mode", mode);



    // ✅ only append if exists
    if (referenceFile) {
      formData.append("reference_image", referenceFile);
    }

    try {
      await decartEdit(formData, (res) => {
        // For video, the result might be different structure
        if (res?.data?.data) {
          setResult(res.data.data);
        } else {
          setResult(res.data); // Fallback
        }
      });
    } catch (err) {
      console.error(err);
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  // Determine file type based on extension or MIME type
  const getFileType = (file) => {
    if (!file) return null;
    
    const videoTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo'];
    const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    
    if (videoTypes.includes(file.type)) {
      return 'video';
    } else if (imageTypes.includes(file.type)) {
      return 'image';
    }
    
    // Fallback to extension check
    const extension = file.name.split('.').pop().toLowerCase();
    const videoExtensions = ['mp4', 'mov', 'avi'];
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
    
    if (videoExtensions.includes(extension)) {
      return 'video';
    } else if (imageExtensions.includes(extension)) {
      return 'image';
    }
    
    return null; // Unknown type
  };

  return (
    <div className="editor-wrapper">
      <div className="container d-flex justify-content-center align-items-center">
        <div className="card editor-card shadow-lg">

          <div className="card-body">

            <h2 className="text-center mb-4">
              {fileType === 'video' ? 'Decart Video Editor' : 'Decart Image Editor'}
            </h2>

            {/* Upload Main File */}
            <div className="mb-3">
              <label className="form-label">
                {fileType === 'video' ? 'Upload Video' : 'Upload Image'}
              </label>
              <input
                type="file"
                className="form-control"
                accept=".mp4,.mov,.avi,.jpg,.jpeg,.png,.gif,.webp"
                onChange={(e) => {
                  const selectedFile = e.target.files[0];
                  setFile(selectedFile);
                  setFileType(getFileType(selectedFile));
                }}
              />
              {file && (
                <small className="text-muted">
                  Selected: {file.name} ({fileType === 'video' ? 'Video' : 'Image'})
                </small>
              )}
            </div>

            {/* Preview */}
            {file && (
              <div className="text-center mb-3">
                {fileType === 'video' ? (
                  <video
                    src={URL.createObjectURL(file)}
                    alt="preview"
                    className="img-fluid rounded shadow preview-video"
                    autoPlay
                    muted
                    loop
                    playsInline
                    controls={false}
                    maxWidth="100%"
                  />
                ) : (
                  <img
                    src={URL.createObjectURL(file)}
                    alt="preview"
                    className="img-fluid rounded shadow preview-image"
                  />
                )}
              </div>
            )}

            {/* Upload Reference (Image only for now) */}
            <div className="mb-3">
              <label className="form-label">
                Reference Image (Optional)
              </label>
              <input
                type="file"
                className="form-control"
                accept=".jpg,.jpeg,.png,.gif,.webp"
                onChange={(e) => setReferenceFile(e.target.files[0])}
              />
              {referenceFile && (
                <small className="text-muted">
                  Selected: {referenceFile.name}
                </small>
              )}
            </div>

            {/* Prompt + reference mode */}
            <div className="mb-3">
              <label className="form-label">Video pipeline</label>
              <select
                className="form-select mb-2"
                value={mode}
                onChange={(e) => setMode(e.target.value)}
              >
                <option value="lucy">Lucy (Edit) - default</option>
                <option value="virtual-try-on">Lucy Virtual Try-On (VTON)</option>
              </select>

              <label className="form-label">Edit Mode</label>
              <select
                className="form-select mb-2"
                value={referenceMode}
                onChange={(e) => setReferenceMode(e.target.value)}
              >
                <option value="both">Prompt + Reference</option>
                <option value="prompt">Prompt Only</option>
                <option value="reference">Reference Only (empty prompt)</option>
              </select>

              <label className="form-label">Edit Prompt</label>

              <input
                type="text"
                className="form-control"
                placeholder={fileType === 'video'
                  ? mode === 'virtual-try-on'
                    ? "Describe garment swap (e.g., change shirt to knitted sweater with teddy design on back)"
                    : "Change the person's outfit to a red dress, Add sunglasses to her face"
                  : "Add sunglasses, jacket..."}

                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                placeholder={undefined}

                autoComplete="off"
                spellCheck={false}
              />
            </div>

            {/* Button */}
            <div className="d-grid mb-4">
              <button
                className="btn btn-primary btn-lg"
                onClick={handleSubmit}
                disabled={loading || !file}
              >
                {loading ? "Processing..." : "Apply Prompt"}
              </button>
            </div>

            {/* Result */}
            {result && (
              <div className="text-center">
                {fileType === 'video' ? (
                  <video
                    src={`data:video/mp4;base64,${result}`}
                    alt="output"
                    className="img-fluid rounded shadow result-video"
                    autoPlay
                    muted
                    loop
                    playsInline
                    controls={false}
                    maxWidth="100%"
                  />
                ) : (
                  <img
                    src={`data:image/png;base64,${result}`}
                    alt="output"
                    className="img-fluid rounded shadow result-image"
                  />
                )}
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default DecartUploadEdit;

